<template>
    <v-dialog persistent v-model="dialog" style="position: relative">
        <spieler-export-filter v-if="dialog" :level="level" :lv-id="lvId" :vereins-id="vereinsId" >
            <div class="cancelIcon">
                <v-btn icon @click="cancel()"><v-icon>mdi-close</v-icon></v-btn>
            </div>
        </spieler-export-filter><!-- vereins-id="11101"-->
    </v-dialog>
</template>

<script>
import SpielerExportFilter from "@/views/spielerExport/spielerExportFilter";
export default {
    name: "spielerExportDialog",
    components: {SpielerExportFilter},
    props: ['param', 'lvId', 'vereinsId', 'level'],
    computed: {
        routeParam(){return this.$route.query[this.param]}
    },
    data: () => ({
        dialog: false
    }),
    methods: {
        cancel(){
            window.history.back()
        }
    },
    watch: {
        routeParam(to, from){
            this.dialog = to && !from
        }
    }

}
</script>

<style scoped>
    .cancelIcon {position: absolute; top: 6px; right: 6px}
</style>